import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

export default function MonthHeader({ date }) {
  return <div className='event-calendar-month-header'>{moment(date).format('MMMM')}</div>;
}

MonthHeader.propTypes = {
  date: PropTypes.string.isRequired,
};
